module.exports = {"430703001":"玉霞街道","430703002":"红云街道","430703003":"郭家铺街道","430703004":"斗姆湖街道","430703101":"蒿子港镇","430703102":"中河口镇","430703103":"十美堂镇","430703104":"牛鼻滩镇","430703105":"韩公渡镇","430703106":"石公桥镇","430703107":"镇德桥镇","430703108":"周家店镇","430703110":"双桥坪镇","430703111":"灌溪镇","430703112":"蔡家岗镇","430703114":"草坪镇","430703115":"石门桥镇","430703116":"谢家铺镇","430703117":"黄土店镇","430703118":"尧天坪镇","430703121":"石板滩镇","430703122":"花岩溪镇","430703204":"许家桥回族维吾尔族乡","430703500":"鼎城区园艺场","430703501":"特种养殖场","430703502":"花岩溪林场","430703503":"贺家山原种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430703.json
// module id = 1709
// module chunks = 0